import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';

import _app from '../server';

import thunk from 'redux-thunk';
import reducers from 'redux/reducers';
import logger from 'redux-logger';

let middleware;
if (_app.logger) {
    middleware = applyMiddleware(thunk, logger);

} else {
    middleware = applyMiddleware(thunk);
}

export default createStore(reducers, composeWithDevTools(
    middleware
));






// WEBPACK FOOTER //
// ./src/redux/store.js